export const register = {
    username: {
        name: 'Username',
        placeholder: 'Username',
        required: 'กรุณากรอกชื่อ-นามสกุล',
        too_short: '',
        invalid: '',
    },
    password: {
        name: 'Password',
        placeholder: 'Password',
        required: 'Please enter password',
        too_short: '',
        invalid: '',
    },
    gender: {
        name: 'เพศ',
        placeholder: 'Gender',
        required: 'Please enter gender',
        too_short: '',
        invalid: '',
        defaultText: 'Gender',
    },
    contactNumber: {
        name: 'Contact Number',
        placeholder: 'Contact Number',
        required: 'กรุณากรอกเบอร์โทรศัพท์มือถือ',
        too_short: '',
        invalid: '',
    },
    email: {
        name: 'อีเมล(ถ้ามี)',
        placeholder: 'Email',
        required: 'กรุณากรอกอีเมล',
        too_short: '',
        invalid: '',
    },
    province: {
        name: 'จังหวัด',
        placeholder: 'จังหวัด',
        required: 'เลือกจังหวัด',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'Birthdate',
        placeholder: 'Birthdate',
        required: 'Please enter birthdate',
        too_short: '',
        invalid: '',

        date: {
            name: 'วัน',
            defaultText: 'วัน',
            required: 'วัน'
        },
        month: {
            name: 'เดือน',
            defaultText: 'เดือน',
            required: 'เดือน'
        },
        year: {
            name: 'ปี',
            defaultText: 'ปี',
            required: 'ปี'
        },
    },
    firstname: {
        name: 'Firstname',
        placeholder: 'Firstname',
        required: 'กรุณากรอกชื่อ-นามสกุล',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: 'Lastname',
        placeholder: 'Lastname',
        required: 'Please enter Lastname',
        too_short: '',
        invalid: '',
    },
    nonetagGender: {
        name: '',
        placeholder: '',
        required: 'เลือกเพศ',
        too_short: '',
        invalid: '',
    },
    CodeRef: {
        name: 'CodeRef',
        placeholder: 'Code Refference',
        required: 'กรุณากรอกรหัส',
        too_short: 'too short',
        invalid: 'invalid',
    }
};
